export default "__VITE_ASSET__Btnu8gmd__"